import { render } from "./GtmTracker.vue?vue&type=template&id=6852334c"
import script from "./GtmTracker.vue?vue&type=script&lang=js"
export * from "./GtmTracker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__